import * as React from 'react';
import Menu from 'rc-menu';
import { browserHistory } from 'react-router';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import { IMenu, IMenuAction } from 'models/menu';
import {
	setSideMenuActiveKey,
	setSideMenuOpenKeys,
	setSideMenuSelectedKeys,
	clearSideMenuData,
} from 'redux/modules/menus/sidemenu';
import { AuthConsumer } from '../../../../../containers';
import { IUserPreferences } from 'models/user/userpreferences';

const { connect } = require('react-redux');

interface IProps {
	routing?: any;
	sideMenu?: IMenu;
	setSideMenuActiveKey?: (activeKey: string) => IMenuAction;
	setSideMenuOpenKeys?: (openKeys: string[]) => IMenuAction;
	setSideMenuSelectedKeys?: (selectedKeys: string[]) => IMenuAction;
	clearSideMenuData?: () => IMenuAction;
	t?: (key: string) => string;
	baseUrlClient?: string;
	baseApi?: string;
	userPreferences?: IUserPreferences;
}

@connect(
	(state: IStore) => ({
		routing: state.routing,
		sideMenu: state.sideMenu,
		baseUrlClient: state.fetchDefault.baseUrlClient,
		baseApi: state.fetchDefault.baseAPI,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		setSideMenuActiveKey: (activeKey: string) => dispatch(setSideMenuActiveKey(activeKey)),
		setSideMenuOpenKeys: (openKeys: string[]) => dispatch(setSideMenuOpenKeys(openKeys)),
		setSideMenuSelectedKeys: (selectedKeys: string[]) => dispatch(setSideMenuSelectedKeys(selectedKeys)),
		clearSideMenuData: () => dispatch(clearSideMenuData()),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalSideMenu extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.handleOnOpenChange = this.handleOnOpenChange.bind(this);
		this.handleOnSelect = this.handleOnSelect.bind(this);
		this.handleOnClick = this.handleOnClick.bind(this);
	}

	public componentDidMount() {
		const routing = this.props.routing;
		if (
			!this.props.sideMenu.activeKey ||
			this.props.sideMenu.activeKey !== routing.locationBeforeTransitions.pathname
		) {
			const openKeys = [];
			const selectedKeys = [];
			let activeKey = '';
			if (routing.locationBeforeTransitions) {
				openKeys.push(
					routing.locationBeforeTransitions.pathname.substr(
						0,
						routing.locationBeforeTransitions.pathname.lastIndexOf('/'),
					),
				);
				selectedKeys.push(routing.locationBeforeTransitions.pathname);
				activeKey = routing.locationBeforeTransitions.pathname;

				this.props.setSideMenuActiveKey(activeKey);
				this.props.setSideMenuOpenKeys(openKeys);
				this.props.setSideMenuSelectedKeys(selectedKeys);
			}
		}
	}

	private handleOnClick(event: any, logout) {
		if (event.key === '/changepassword') {
			const baseUrlClient = this.props.baseUrlClient;
			const baseApi = this.props.baseApi;
			const changePasswordLink =
				baseApi +
				'userenter/changepassword?returnUrl=' +
				baseUrlClient +
				'/userprofile?passwordchanged=true%26userId=' +
				this.props.userPreferences.id;
			window.location.href = changePasswordLink;
		} else if (event.key === '/signout') {
			logout();
		} else {
			browserHistory.push(event.key);
		}
	}

	private handleOnOpenChange(openKeys: string[]) {
		this.props.setSideMenuOpenKeys(openKeys);
	}

	private handleOnSelect(data: any) {
		this.props.setSideMenuActiveKey(data.key);
		this.props.setSideMenuSelectedKeys(data.selectedKeys);
	}

	public render() {
		const { selectedKeys, openKeys, activeKey } = this.props.sideMenu;

		return (
			<AuthConsumer>
				{({ logout }) => (
					<Menu
						className="sidemenu"
						mode="inline"
						onClick={(event: any) => {
							this.handleOnClick(event, logout);
						}}
						onSelect={this.handleOnSelect}
						onOpenChange={this.handleOnOpenChange}
						openKeys={openKeys}
						selectedKeys={selectedKeys}
						activeKey={activeKey}
					>
						{this.props.children}
					</Menu>
				)}
			</AuthConsumer>
		);
	}
}

export { PortalSideMenu };
